import React from 'react';

import { routes } from '../../../constants';
import StripeTeachersPage from '../StripeTeachersPage/StripeTeachersPage';
import useRequireStripeUser from '../useRequireStripeUser';

/**
 * Route wrapper for `/stripe-school/teachers`. A non-Stripe (Zuora) admin
 * landing here is redirected to the legacy `/school/teachers` page — matches
 * the FE Gating contract in
 * `apps/docs/content/guides/school-teacher-invitations.md`.
 */
const StripeTeachersRoute: React.FC = () => {
	const { isReady, matches } = useRequireStripeUser({
		mustBeStripe: true,
		redirectTo: `/${routes.schoolAdminTeachers.root}`,
	});

	if (!isReady || !matches) return null;

	return <StripeTeachersPage />;
};

export default StripeTeachersRoute;
